import { UserFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type OperationsAdminVenueTalentCreateFragment = Omit<UserFragment, 'id' | 'role' | 'type' | 'status' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'user_role' | 'user_type' | 'user_status'>

export const OperationsAdminVenueTalentCreateSchema: FormSchema<OperationsAdminVenueTalentCreateFragment> = {
    id: "talent",
    title: "Talent",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        email: {
            group: 'default',
            label: "Email",
            type: "email",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                },
                email: {
                    message: "{field} is invalid"
                },
                email_available: {
                    message:  "{field} is invalid"
                }
            }
        },
        first_name: {
            group: 'default',
            label: "First Name",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        last_name: {
            group: 'default',
            label: "Last Name",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        alias: {
            group: 'default',
            label: "Artist Name / Alias",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        color: {
            group: 'default',
            label: "Artist Color",
            type: "color-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        genres: {
            group: 'default',
            label: "Genres Played",
            type: "multi-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line1: {
            group: 'default',
            label: "Address Line1",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line2: {
            group: 'default',
            label: "Address Line2",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        city: {
            group: 'default',
            label: "City",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        state: {
            group: 'default',
            label: "State",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        postal_code: {
            group: 'default',
            label: "Postal Code",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        bday: {
            group: 'default',
            label: "BirthDate",
            type: "date-picker",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        phone: {
            group: 'default',
            label: "Phone",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        website: {
            group: 'default',
            label: "Website",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        instagram: {
            group: 'default',
            label: "Instagram",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        facebook: {
            group: 'default',
            label: "Facebook",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        x: {
            group: 'default',
            label: "X",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        tiktok: {
            group: 'default',
            label: "Tiktok",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        timezone: {
            group: 'default',
            label: "Timezone",
            type: "timezone-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}

export type OperationsAdminVenueTalentUpdateFragment = Omit<UserFragment, 'id' | 'role' | 'type' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'user_role' | 'user_type' | 'user_status'>

export const OperationsAdminVenueTalentUpdateSchema: FormSchema<OperationsAdminVenueTalentUpdateFragment> = {
    id: "talent",
    title: "Talent",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        status: {
            group: 'default',
            label: "Status",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        email: {
            group: 'default',
            label: "Email",
            type: "email",
            editable: false,
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        first_name: {
            group: 'default',
            label: "First Name",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        last_name: {
            group: 'default',
            label: "Last Name",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        alias: {
            group: 'default',
            label: "Artist Name / Alias",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        color: {
            group: 'default',
            label: "Artist Color",
            type: "color-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        genres: {
            group: 'default',
            label: "Genres Played",
            type: "multi-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line1: {
            group: 'default',
            label: "Address Line1",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        address_line2: {
            group: 'default',
            label: "Address Line2",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        city: {
            group: 'default',
            label: "City",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        state: {
            group: 'default',
            label: "State",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        postal_code: {
            group: 'default',
            label: "Postal Code",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        bday: {
            group: 'default',
            label: "BirthDate",
            type: "date-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        phone: {
            group: 'default',
            label: "Phone",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        website: {
            group: 'default',
            label: "Website",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        instagram: {
            group: 'default',
            label: "Instagram",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        facebook: {
            group: 'default',
            label: "Facebook",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        x: {
            group: 'default',
            label: "X",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        tiktok: {
            group: 'default',
            label: "Tiktok",
            type: "text",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        timezone: {
            group: 'default',
            label: "Timezone",
            type: "timezone-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}